import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

let style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  maxHeight: "100vh",
  maxWidth: "100vw",
};

export const ModalComponent = (props: any) => {
  // const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);
  style = { ...style, ...props.style };
  return (
    <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal open={props.isModalOpen} onClose={props.hideModal}>
        <Box sx={style}>
          {props.customHeader ? (
            <></>
          ) : (
            <div className="mui-modal-header">
              <h4>{props.title}</h4>
              <IconButton aria-label="close" onClick={props.hideModal}>
                <CloseIcon />
              </IconButton>
            </div>
          )}

          {props.children}
        </Box>
      </Modal>
    </div>
  );
};
export default ModalComponent;
